import HttpInstance from "./http.api";

export const EditRestaurantSubmit = (id:string,resObj:any)=>{
    const respData= HttpInstance.patch("/restaurant/updaterestaurant?id="+id,resObj)
    return respData
}
